import { selfAxios } from "../../../../../axios/selfAxios.js";
async function reqNewGetSpecialPageByCon(params) {
  const {
    data: { data }
  } = await selfAxios.post("/designapi/design/salesRendering/newGetSpecialPageByCon", params, {
    _cache: true
  });
  return data;
}
export { reqNewGetSpecialPageByCon };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designapi/design/salesRendering/newGetSpecialPageByCon/post.js